/* eslint-disable */
import React from 'react';
import { Users, Plus, Search, Filter, Phone, Mail, MoreVertical } from 'lucide-react';

const clients = [
  { id: 1, name: 'PT Maju Bersama',    type: 'Corporate',  cases: 4, contact: '+62 811-234-5678', email: 'legal@majubersama.co.id',  status: 'Active'   },
  { id: 2, name: 'Ahmad Fauzi',         type: 'Individual', cases: 1, contact: '+62 812-345-6789', email: 'ahmad.fauzi@email.com',      status: 'Active'   },
  { id: 3, name: 'CV Karya Utama',      type: 'Corporate',  cases: 2, contact: '+62 813-456-7890', email: 'info@karyautama.com',         status: 'Inactive' },
  { id: 4, name: 'Siti Rahayu',         type: 'Individual', cases: 1, contact: '+62 814-567-8901', email: 'siti.rahayu@email.com',       status: 'Active'   },
  { id: 5, name: 'PT Nusantara Jaya',   type: 'Corporate',  cases: 3, contact: '+62 815-678-9012', email: 'admin@nusantarajaya.co.id',   status: 'Active'   },
  { id: 6, name: 'Bapak Hendra Lim',   type: 'Individual', cases: 2, contact: '+62 816-789-0123', email: 'hendra.lim@email.com',        status: 'Active'   },
];

export default function ClientsPage() {
  return (
    <div style={{ maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 28 }}>
        <div>
          <h1 style={{ fontSize: 24, fontWeight: 700, color: '#0f172a', margin: 0 }}>Clients</h1>
          <p style={{ fontSize: 14, color: '#64748b', marginTop: 4 }}>Manage all client records and relationships.</p>
        </div>
        <button style={{
          display: 'flex', alignItems: 'center', gap: 8,
          background: 'linear-gradient(135deg, #1a2d5a, #1e3a6e)',
          color: '#fff', border: 'none', borderRadius: 10,
          padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(26,45,90,0.3)',
          transition: 'transform 0.15s',
        }}>
          <Plus size={16} /> Add Client
        </button>
      </div>

      {/* Search & Filter */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <div style={{
          flex: 1, display: 'flex', alignItems: 'center', gap: 10,
          background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10,
          padding: '0 14px', height: 42,
          boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        }}>
          <Search size={15} color="#94a3b8" />
          <input placeholder="Search clients…" style={{ border: 'none', outline: 'none', fontSize: 14, color: '#334155', width: '100%', background: 'transparent' }} />
        </div>
        <button style={{
          display: 'flex', alignItems: 'center', gap: 8,
          background: '#fff', border: '1px solid #e2e8f0',
          borderRadius: 10, padding: '0 16px', height: 42,
          fontSize: 14, color: '#64748b', cursor: 'pointer',
          boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        }}>
          <Filter size={15} /> Filter
        </button>
      </div>

      {/* Client cards grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>
        {clients.map(c => (
          <div key={c.id} style={{
            background: '#fff', borderRadius: 14,
            border: '1px solid #f1f5f9',
            padding: '20px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
            transition: 'transform 0.18s, box-shadow 0.18s',
            cursor: 'pointer',
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.10)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.05)'; }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                  width: 44, height: 44, borderRadius: 12,
                  background: c.type === 'Corporate' ? 'linear-gradient(135deg,#3b82f6,#6366f1)' : 'linear-gradient(135deg,#f59e0b,#f97316)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff', fontWeight: 700, fontSize: 16,
                }}>{c.name[0]}</div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#0f172a' }}>{c.name}</div>
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>{c.type}</div>
                </div>
              </div>
              <span style={{
                fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 20,
                background: c.status === 'Active' ? '#f0fdf4' : '#f8fafc',
                color: c.status === 'Active' ? '#16a34a' : '#94a3b8',
              }}>{c.status}</span>
            </div>
            <div style={{ fontSize: 13, color: '#64748b', marginBottom: 10 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 5 }}>
                <Phone size={12} color="#94a3b8" /> {c.contact}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                <Mail size={12} color="#94a3b8" /> {c.email}
              </div>
            </div>
            <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 12, fontSize: 12, color: '#64748b' }}>
              <span style={{ fontWeight: 600, color: '#3b82f6' }}>{c.cases}</span> active cases
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
